export const medicos = [
  {
    codMed: 1,
    codFunc: '90001',
    nome: 'ANA PAULA DE MAGALHAES LEITE TUROLA',
    apelido: 'DRA ANA PAULA',
    salaId: 3,
  },
  {
    codMed: 2,
    codFunc: '90003',
    nome: 'BENITO GARBELINI JUNIOR',
    apelido: 'DR BENITO',
    salaId: 1,
  },
  {
    codMed: 3,
    codFunc: '90009',
    nome: 'ERALDO ANTONIO PELLOSO',
    apelido: 'DR ERALDO',
    salaId: 4,
  },
  {
    codMed: 4,
    codFunc: '90015',
    nome: 'LUCIENNE SANTOS FERRO',
    apelido: 'DRA LUCIENNE',
    salaId: 6,
  },
  {
    codMed: 5,
    codFunc: '90016',
    nome: 'MARIA CRISTINA DE MELLO BARBOZA SILVA',
    apelido: 'DRA MARIA CRISTINA',
    salaId: 9,
  },
  {
    codMed: 648,
    codFunc: '90004',
    nome: 'BRUNO COELHO RIBEIRO',
    apelido: 'DR BRUNO',
    salaId: 7,
  },
  {
    codMed: 1265,
    codFunc: '90013',
    nome: 'JOYCE GONCALVES BERTELI',
    apelido: 'DRA JOYCE',
    salaId: 2,
  },
  {
    codMed: 1233,
    codFunc: '90024',
    nome: 'ROBERTA PIANOVSKI AUR',
    apelido: 'DRA ROBERTA',
    salaId: 10,
  },
  /*   {
    codMed: 1713,
    codFunc: '90007',
    nome: 'DAUANE CRISTINE ORSO TOSCAN',
    apelido: 'DRA DAUANE',
    salaId: 2,
  }, */
  {
    codMed: 69,
    codFunc: '90010',
    nome: 'JOSE ANTONIO GALBIATTI',
    apelido: 'DR GALBIATTI',
    salaId: 5,
  },
  {
    codMed: 7,
    codFunc: '90000',
    nome: 'PREVENCOR',
    apelido: 'PREVENCOR',
    salaId: 8,
  },
  {
    codMed: 2500,
    codFunc: '90011',
    nome: 'ECG EXTERNO',
    apelido: 'ECG-EXT',
    salaId: 12,
  },
];

export const salas = [
  {
    id: 1,
    nome: 'Sala 1',
    ativa: true,
  },
  {
    id: 2,
    nome: 'Sala 2',
    ativa: true,
  },
  {
    id: 3,
    nome: 'Sala 3',
    ativa: true,
  },
  {
    id: 4,
    nome: 'Sala 4',
    ativa: true,
  },
  {
    id: 5,
    nome: 'Sala 5',
    ativa: true,
  },
  {
    id: 6,
    nome: 'Sala 6',
    ativa: true,
  },
  {
    id: 7,
    nome: 'Sala 7',
    ativa: true,
  },
  {
    id: 8,
    nome: 'Sala 8',
    ativa: false,
  },
  {
    id: 9,
    nome: 'Sala 9',
    ativa: true,
  },
  {
    id: 10,
    nome: 'Sala 10',
    ativa: true,
  },
  {
    id: 12,
    nome: 'Sala 12',
    ativa: false,
  },
  {
    id: 20,
    nome: 'Recepção',
    ativa: false,
  },
];

const COD_MEDICO_APENAS_FUNC = 1713;

/** Resolve codFunc e nome do usuário logado (FUNC ou médico) para gravação na agenda. */
// TODO: verificar outros lugares resolveCodFuncDestino();
export function resolveUsuarioAgenda({ func, doctor } = {}) {
  const codFuncFunc = func?.CODFUNC ?? func?.codFunc;
  if (codFuncFunc != null && codFuncFunc !== '') {
    return {
      codFunc: String(codFuncFunc),
      nome: func?.NOMEFUNC || func?.nome || '',
    };
  }

  const codMed = doctor?.CODMED ?? doctor?.codMed;
  if (codMed != null) {
    const medico = medicos.find((m) => String(m.codMed) === String(codMed));
    if (medico) {
      return {
        codFunc: String(medico.codFunc),
        nome: medico.apelido || medico.nome || '',
      };
    }
  }

  return { codFunc: '', nome: '' };
}

export function getMedicosAgenda({ isFunc = false } = {}) {
  if (isFunc) return medicos;
  return medicos.filter((medico) => medico.codMed !== COD_MEDICO_APENAS_FUNC);
}

export const procedimentos = [
  { codProcedi: 1, nome: 'Consulta Cardiológica' },
  { codProcedi: 58, nome: 'Retorno' },
  { codProcedi: 2, nome: 'Eletrocardiograma (ECG)' },
  { codProcedi: 3, nome: 'Ecocardiograma' },
  { codProcedi: 4, nome: 'Ecodoppler' },
  { codProcedi: 5, nome: 'Teste Ergométrico' },
  { codProcedi: 6, nome: 'MAPA' },
  { codProcedi: 7, nome: 'Holter' },
  { codProcedi: 1000, nome: 'NULO' },
];

export const convenios = [
  { codConv: 1, nome: 'AMIL' },
  { codConv: 2, nome: 'AMAFRESP' },
  { codConv: 3, nome: 'APEOESP' },
  { codConv: 4, nome: 'CABESP' },
  { codConv: 5, nome: 'CASSI' },
  { codConv: 6, nome: 'ECONOMUS' },
  { codConv: 7, nome: 'FUNDAÇÃO CESP' },
  { codConv: 8, nome: 'IAMSP' },
];
